import { useMemo } from 'react';
import lodashGet from 'lodash/get';
import lodashSome from 'lodash/some';
import { useListingMLSByZipcode } from './useListingMLS';

export function useListingMlsFlags(listing) {
    const { data, isFetched } = useListingMLSByZipcode(listing);

    const relocateListingAgentInfo = useMemo(() => {
        return lodashGet(data, '[0].relocate_listing_agent_info_on_detail_page', false);
    }, [data]);

    const mlsLogoDisplayNearListingDetails = useMemo(() => {
        return lodashGet(data, '[0].mls_logo_display_near_listing_details', false);
    }, [data]);

    const logo = useMemo(() => {
        return lodashGet(data, '[0].logo', false);
    }, [data]);

    const hideAgent = useMemo(() => {
        return lodashSome(data, 'hide_listing_agent_from_detail_page');
    }, [data]);

    return {
        data,
        isFetched,
        relocateListingAgentInfo,
        mlsLogoDisplayNearListingDetails,
        logo,
        hideAgent,
    };
}
